import React from "react";
import { connect } from "react-redux";
import { loadSubMenu } from "../actions";

import MainPlanMovilidad from "./main";
import Configuracion from "./configuracion";
import FinalizarMiPlanMovilidad from "./finalizar";

class MiPlanMovilidad extends React.PureComponent {
  constructor(props) {
    super(props);
    this.loadSubMenu();
  }

loadSubMenu = () => {
  const tabs = [
    { text: "Main", contentId: 0 },
    { text: "Configuracion", contentId: 1 },
    { text: "Finalizar", contentId: 2 },

  ];
  this.props.dispatch(loadSubMenu(tabs, tabs.length ? tabs[0].contentId : null));
}

renderBody = () => {
  switch (this.props.subMenuPosition) {
    case 0: {
      return (<MainPlanMovilidad />);
    }
    case 1: {
      return (<Configuracion />);
    }
    case 2: {
      return (<FinalizarMiPlanMovilidad />);
    }
    default:
      return <div />;
  }
}

render() {
  return (
    <React.Fragment>
      {this.renderBody()}
    </React.Fragment>
  );
}
}

const mapStateToProps = (state) => ({
  planMovilidad: state.planMovilidad,
  subMenuPosition: state.planMovilidad.subMenuPosition,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(MiPlanMovilidad);
